<template>
  <div>
    <operations-list-card
        :operation-definition="operationDefinition(operationType)"
        :operations="operations"
        :pagination="pagination"
        :key="operationType"
        @pageChanged="pageChanged"
        @sortChanged="sortChanged"
        @focusedChanged="handleFocusedChanged"
        @deleteByQueryRequested="handleDeleteByQuery"
        @deleteSelectedRequested="handleDeleteSelection"
        @add="handleAdd"
        @clone="handleClone"
        @delete="handleDelete"
        @csvRequested="handleCsvRequest"
        @paySelectedRequested="handleGeneratePaymentFromListing"
        @payByQueryRequested="handleGeneratePaymentFromQuery"
        :loading="loading"
    />
    <v-modal name="operationModal" style="background-color: rgba(10,10,10,0.76)">
      <operation-editor-layout v-if="focusedOperation != null"
                               :key="focusedOperation.id"
                               :operation="focusedOperation"
                               @save="handleSave"
                               @cancel="handleCancel"
      />
    </v-modal>
    <v-modal name="paymentModal" classes="transparent-modal" style="background-color: rgba(10,10,10,0.76)"
             :width="800" :height="600">
      <basic-card>
        <template slot="header">
          Payment from cash-event
        </template>
        <template v-if="paymentsLoading">
          <loader indefinite message="Loading cash-events for payments"/>
        </template>
        <template v-else>
          {{ paymentsFromCashEvent.paymentBatch }}
          <p>Following cash-events will be added to specified payment batch:</p>
          <data-table
              :configuration="paymentsFromEventTableConfig"
              :data="paymentsFromCashEvent.cashEvents"
              @remove="handleRemoveCashEvent"
              style="height: 350px; overflow-y: scroll;"
              component-id="cash-events-to-payment-batch-list"
          />
          <br/>
          <info-box warning v-if="cashEventsWithPayment">
            Some of cash-events above are already present in Payment Batches.
          </info-box>
          <form-wrapper>
            <form-select-input required caption="Payment batch" :options="paymentBatchOptions"
                               v-model="paymentsFromCashEvent.paymentBatch"/>
          </form-wrapper>
          <simple-button @press="processPaymentsToBatch"
                         :disabled="paymentsFromCashEvent.cashEvents.length == 0">
            Process
          </simple-button>
        </template>

      </basic-card>
    </v-modal>
  </div>
</template>

<script>
import DashboardLayout from "../components/layout/DashboardLayout";
import OperationsListCard from "../cards/OperationsListCard";
import {mapGetters} from "vuex";
import OperationStore from "../stores/operations-store"
import OperationFormCard from "../cards/OperationFormCard";
import CashEventListCard from "../cards/CashEventListCard";
import SimpleLayout from "../components/layout/SimpleLayout";
import BasicCard from "../components/layout/BasicCard";
import FormWrapper from "../components/form/FormWrapper";
import FormSelectInput from "../components/form/FormSelectInput";
import SimpleButton from "../components/button/SimpleButton";
import DataTable from "../components/table/DataTable";
import PaymentsView from "./PaymentsView";
import PaymentStore from '../stores/payment-store'
import InfoBox from "../components/InfoBox";
import Loader from "../components/Loader";
import OperationEditorLayout from "@/layout/OperationEditorLayout";

export default {
  name: "OperationsListingView",
  components: {
    OperationEditorLayout,
    Loader,
    InfoBox,
    DataTable,
    SimpleButton,
    FormSelectInput,
    FormWrapper,
    BasicCard, SimpleLayout, CashEventListCard, OperationFormCard, OperationsListCard, DashboardLayout
  },
  data: function () {
    return {
      paymentsFromCashEvent: {
        cashEvents: []
      },
      operationType: this.$route.params.operationType,
      focusedOperation: null,
      actualPage: 0,
      pageSize: 20,
      cashEvents: [],
      operationSaveError: Object,
      loading: false,
      operationSaving: false,
      paymentsLoading: false,
      paymentsFromEventTableConfig: {
        columns: [
          {
            caption: "",
            datum: d => d.existingPayments > 0 ? "!" : "",
            style: d => ({color: "#C84A4B !important"})
          },
          {
            caption: "Id",
            datum: d => d.id.substr(d.id.length - 5)
          },
          {
            caption: "Date",
            datum: d => this.$formats.formatDate(d.timestamp)
          },
          {
            caption: "Amount",
            datum: d => this.$formats.formatAmount(d.amount / 1000000)
          },
          {
            caption: "Currency",
            datum: d => d.currency
          },
          {
            caption: "Type",
            datum: d => d.type
          },
          {
            caption: "Account",
            datum: d => this.account(d.account).name
          },
          {
            caption: "Source",
            datum: d => d.source,
          }
          // ,
          // {
          //     caption: "Existing payments",
          //     datum: d => d.existingPayments
          // }
        ],
        actions: [
          {
            name: "remove",
            icon: "trash",
            tooltip: "Remove payment from addition to payment batch"
          }
        ]
      }
    }
  },
  methods: {
    pageChanged(page, query, pageSize) {
      this.actualPage = page;
      this.pageSize = pageSize;
      this.loading = true;
      this.$store.dispatch(`${this.operationType}/refreshOperations`, {
        requestedPage: this.actualPage,
        size: this.pageSize,
        query: query
      }).then(() => this.loading = false);
    },
    sortChanged(sort, query) {
      this.loading = true;
      this.$store.commit(`${this.operationType}/clearCreatedOperations`);
      this.$store.dispatch(`${this.operationType}/refreshOperations`, {
        requestedPage: this.actualPage,
        query: query,
        sort: sort
      }).then(() => this.loading = false);
    },
    handleRemoveCashEvent(cashEvent) {
      this.paymentsFromCashEvent.cashEvents = this.paymentsFromCashEvent.cashEvents.filter(ce => ce != cashEvent);
    },
    handleGeneratePaymentFromQuery(query) {
      this.paymentsLoading = true;
      let cashEventsForPayment = [];
      const LIMIT = 500;
      this.$modal.show("paymentModal");
      this.$store.dispatch(`${this.operationType}/fetchOperations`, {
        query,
        size: LIMIT,
        page: 0
      }).then(ops => {
        let operations = ops.list;
        if (ops.meta.count > LIMIT) {
          this.$notify({
            group: 'application', type: "error",
            title: "Cannot process payments to batch",
            text: `There were ${ops.meta.count} operations to be processed into payment batch. Currently supported limit is ${LIMIT}.
                        Try reducing number of operations by adding more criterias to filter.`,
            duration: 10000
          })
          this.$modal.hide("paymentModal");
          return;
        }
        Promise.all(operations.map(op => {
          return this.$store.dispatch("cashEvents/loadCashEventsByOperation", {operationId: op.id}).then(() => {
            cashEventsForPayment.push(...this.cashEventsByOperation(op.id).filter(ce => ce.amount < 0));
          });
        })).then(() => {
          this.handleGeneratePayment(cashEventsForPayment);
        })
      })

    },
    handleGeneratePaymentFromListing(operations) {
      this.paymentsLoading = true;
      this.$modal.show("paymentModal");
      let cashEventsForPayment = [];
      Promise.all(operations.map(op => {
        return this.$store.dispatch("cashEvents/loadCashEventsByOperation", {operationId: op.id}).then(() => {
          cashEventsForPayment.push(...this.cashEventsByOperation(op.id).filter(ce => ce.amount < 0));
        });
      }))
          .then(() => {
            this.handleGeneratePayment(cashEventsForPayment);
          })

    },
    handleGeneratePayment(payload) {
      if (Array.isArray(payload)) this.paymentsFromCashEvent.cashEvents = payload;
      else this.paymentsFromCashEvent.cashEvents = [payload];
      Promise.all(this.paymentsFromCashEvent.cashEvents.map(
          cashEvent => {
            let paymentQuery = {
              parameters: {
                "cashEventId": {
                  operator: "eq",
                  type: "string",
                  value: cashEvent.id,
                }
              }
            };
            let verificationStoreName = `${cashEvent.id}-paymentsVerification`;
            this.$store.registerModule(verificationStoreName, PaymentStore());
            return this.$store.dispatch(`${verificationStoreName}/refreshPaymentsPaged`, {
              page: 0,
              query: paymentQuery
            })
                .then(() => {
                  cashEvent.existingPayments = this.$store.state[verificationStoreName].payments.length;
                  this.$store.unregisterModule(verificationStoreName);
                })
          }
      ))
          .then(() => {
            this.paymentsLoading = false;
          })

      this.$store.dispatch("paymentBatches/refreshPaymentBatches").then(() => {
        this.$nextTick(() => {
          this.$set(this.paymentsFromCashEvent, 'paymentBatch', this.$store.state['paymentBatches'].activePaymentBatch)
        });
      });
    },
    handleFocusedChanged(focused) {
      this.focusedOperation = focused;
      this.operationSaveError = null
      if (focused != null) {
        this.$modal.show("operationModal");
      }
      // if (this.focusedOperation != null) {
      //   this.$store.dispatch("cashEvents/loadCashEventsByOperation", {operationId: this.focusedOperation.id}).then(() => {
      //     this.cashEvents = this.cashEventsByOperation(this.focusedOperation.id);
      //   });
      // }
    },
    handleDelete(toDelete, query) {
      if (confirm(this.$t("operation.deleteOperataionConfirmation"))) {
        return this.$store.dispatch(`${this.operationType}/deleteOperation`, toDelete)
            .then(res => {
              this.$notify({
                group: 'application',
                title: 'Operation was deleted',
                text: `Operation was successfully deleted`,
                type: "ok"
              });
              this.$store.dispatch(`${this.operationType}/refreshOperations`, {
                requestedPage: this.actualPage,
                query: query
              })
            })
      }
    },
    handleClone(clone) {
      this.focusedOperation = this.$_.cloneDeep(clone);
      this.operationSaveError = null
      this.focusedOperation.id = undefined;
      this.focusedOperation.creator = undefined;
      this.focusedOperation.updatedBy = undefined;
      this.$modal.show("operationModal");
    },
    handleAdd() {
      this.operationSaveError = null
      this.focusedOperation = {
        source: 'frontend',
        actualStatus: 'LIVE',
        securityGroup: this.actualUser.defaultSecurityGroup,
        operationDefinition: this.operationType,
        content: {}
      };
      this.handleFocusedChanged(this.focusedOperation);
    },
    handleCancel() {
      this.focusedOperation = null;
      this.operationSaveError = null
      this.$modal.hide("operationModal");
    },
    handleSave(savePayload) {
      const operation = savePayload.operation;
      const operationLinks = savePayload.links;

      this.operationSaving = true;
      return this.$store.dispatch(`${this.operationType}/saveOperation`, operation)
          .then((savedOp) => {
            console.log(savedOp);
            const linkDefinitions = Object.keys(operationLinks.primaryLinks);
            const currentOperationId = savedOp.id;
            return Promise.all(linkDefinitions.map(linkDef => {
              const targetOperationId = operationLinks.primaryLinks[linkDef];
              return this.$store.dispatch("operationLinks/saveOperationLink", {
                primarySide: targetOperationId,
                secondarySide: currentOperationId,
                linkDefinition: linkDef
              })
            }))
          })
          .then(() => {
            this.operationSaving = false;
            this.$modal.hide("operationModal");
            this.$notify({
              group: 'application',
              title: 'Operation saved',
              text: `Operation ${this.focusedOperation.id ? this.focusedOperation.id : ""} saved`,
              type: "ok"
            });
            this.focusedOperation = null
            this.operationSaveError = null
          }, (error) => {
            this.operationSaveError = {content: error.response.data, status: error.response.status};
            this.operationSaving = false
          });

    },
    handleDeleteSelection(selection, query) {
      this.loading = true;
      Promise.all(
          selection.map(op => {
            return this.$store.dispatch(`${this.operationType}/deleteOperation`, op)
          })
      )
          .then(() => {
            this.$notify({
              group: 'application',
              title: 'Selected operations deleted',
              text: `Selected operations were deleted`,
              type: "ok"
            });
          })
          .then(() => this.$store.dispatch(`${this.operationType}/refreshOperations`, {
            requestedPage: 0,
            query: query
          }))
          .then(() => this.loading = false)
          .catch(() => this.loading = false)
    },
    handleCsvRequest(query) {
      this.$store.dispatch(`${this.operationType}/downloadCsv`, {query: query});
    },
    handleDeleteByQuery(query) {
      this.loading = true;
      this.$store.dispatch(`${this.operationType}/deleteOperationsByQuery`, query)
          .then(() => {
            this.$notify({
              group: 'application',
              title: 'Operations deleted',
              text: `Operations specified in query were deleted`,
              type: "ok"
            });
          })
          .then(() => this.$store.dispatch(`${this.operationType}/refreshOperations`, {
            requestedPage: 0,
            query: query
          }))
          .then(() => this.loading = false)
    },
    processPaymentsToBatch() {
      Promise.all(this.paymentsFromCashEvent.cashEvents.map(cashEvent => ({
        batchId: this.paymentsFromCashEvent.paymentBatch,
        amount: Math.abs(cashEvent.amount / 1000000),
        cashEventId: cashEvent.id,
        currencyId: cashEvent.currency,
        counterPartyId: cashEvent.counterParty,
        sourceAccountRef: {
          accountId: cashEvent.account,
          accountNumber: this.account(cashEvent.account).accountNumber,
          bankCode: this.bank(this.account(cashEvent.account).bankId).code
        },
        targetAccountRef: {accountId: cashEvent.counterAccount},
        dueDate: cashEvent.timestamp,
        realizationDetails: {},
        czePaymentDetails: {},
        foreignPaymentDetails: {beneficiaryDetails: {}},
        memo: `${cashEvent.operation}`
      }))
          .map(payment => this.$store.dispatch('payments/savePayment', payment)
          ))
          .then(() => {
            this.$modal.hide("paymentModal");
            this.$notify({
              group: 'application',
              title: 'Payment processed',
              text: `Payments were processed to payment batch`,
              type: "ok"
            });
          })
    }
  },
  computed: {
    ...mapGetters({
      operationDefinition: "operationDefinitions/operationDefinition",
      cashEventsByOperation: "cashEvents/cashEventsByOperation",
      paymentBatches: "paymentBatches/paymentBatches",
      account: "banking/account",
      bank: "banking/bank",
      actualPrincipal: "auth/actualPrincipal",
      users: "users/users"
    }),
    actualUser() {
      return this.users.find(usr => usr.username == this.actualPrincipal.username);
    },
    cashEventsWithPayment() {
      return this.paymentsFromCashEvent.cashEvents.find(cashEvent => cashEvent.existingPayments > 0);
    },
    paymentBatchOptions() {
      return this.paymentBatches.filter(batch => batch.states[batch.states.length - 1].type === 'IN_PROGRESS').map(batch => ({
        name: batch.displayName,
        id: batch.id
      }))
    },
    operations() {
      return {
        actualItems: this.$store.getters[`${this.operationType}/getActualPageItems`],
        modifiedItems: this.$store.getters[`${this.operationType}/getCreatedItems`]
      }
    },
    pagination() {
      return this.$store.getters[`${this.operationType}/getPaginationController`]
    }
  },
  watch: {
    '$route': {
      handler(to, from) {
        this.operationType = this.$route.params.operationType;
        if (typeof this.$store._modules.root._children[this.operationType] != 'undefined') {
          this.$store.unregisterModule(this.operationType);
        }
        this.selectedOperations = [];
        this.operationType = this.$route.params.operationType;
        this.$store.registerModule(this.operationType,
            OperationStore(this.operationType));
        this.loading = true
        this.$store.dispatch(`${this.operationType}/refreshOperations`, {
          requestedPage: 0, query: {
            parameters: {
              operationDefinition: {
                operator: "eq",
                type: "string",
                value: this.operationType
              },
              actualStatus: {type: 'enum', operator: 'in', value: 'LIVE', negation: false}
            }
          },
          sort: {sortField: 'createdTimestamp', direction: 'DESC'}
        })
            .then(() => this.loading = false);
      },
      immediate: true
    }
  },
  mounted() {

  },
  destroyed() {

  }

}
</script>

<style lang="scss" scoped>
.transparent-modal {
  background-color: transparent;
}
</style>
